import { DEFAULT_FONTSIZE } from "../utils/utils";
import CustomTextArea from "./CustomTextArea";

interface FormattedTextProps {
  value: string;
  minRows?: number;
  color?: string;
}

const FormattedText = ({ value, minRows, color }: FormattedTextProps) => {
  return (
    <CustomTextArea
      value={value}
      minRows={minRows}
      sx={{
        marginBottom: 0,
        "& .MuiInputBase-input": { ...DEFAULT_FONTSIZE, color: color },
      }}
      InputProps={{ readOnly: true, disableUnderline: true }}
      variant="standard"
    />
  );
};

export default FormattedText;
